/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

import * as React from 'react';
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Fade from "@mui/material/Fade"
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import stylePropType from 'react-style-proptype';

const cardStyle = {
  card: {
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.4)",
    borderRadius: "4.44915px",
    background: "#424242",
    width: 200,
    height: 180
  },
  cardMedia: {
    // backgroundColor: '#262b32',
    shadow: "none",
    height: { md: 100 },
    objectFit: "cover"
  },
}

export default function OptionCard(props) {
  const { item, isPortrait, descriptionStyle } = props;

  if(isPortrait) {
    return (
      <Fade style={{ transformOrigin: "0 0 0" }} timeout={500} in appear>
        <Card sx={{ display: 'flex', marginTop: 2 }}>
          {item.img &&
          <CardMedia
            component="img"
            sx={cardStyle.cardMedia}
            image={item.img.src}
            alt="option image"
          />}
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flex: '1 0 auto' }}>
              <Typography 
                component="div" 
                variant="h5"
                color='primary.contrastText'
                sx={descriptionStyle}
              >
                {item.description.text} 
              </Typography>
            </CardContent>
          </Box>
        </Card>
      </Fade>
    );
  }

  return (
    <Fade style={{ transformOrigin: "0 0 0" }} timeout={500} in appear>
      <Card sx={cardStyle.card}>
        {item.img &&
          <CardMedia
            component='img'
            src={item.img.src}
            alt='item_image'
            sx={cardStyle.cardMedia}
          />
        }
        {item.description &&
          <CardContent sx={{ textAlign: "center" }}>
            <Typography
              gutterBottom
              variant='h5'
              component='div'
              color='primary.contrastText'
              sx={descriptionStyle}
            >
              {item.description.text}
            </Typography>
          </CardContent>
        }
      </Card>
    </Fade>
  );
}

OptionCard.propTypes = {
  item: PropTypes.shape({
    img: PropTypes.shape({
      src: PropTypes.string
    }),
    description: PropTypes.shape({
      text: PropTypes.string.isRequired 
    }).isRequired 
  }).isRequired,
  descriptionStyle: stylePropType,
  isPortrait: PropTypes.bool
}

OptionCard.defaultProps = {
  isPortrait: false,
  descriptionStyle: undefined
}